import { useSelector } from 'react-redux';
export const useShowTotal = () => {
    const reduxShowTotal = useSelector((state) => state.filters.showTotal);
    return reduxShowTotal;
};
